export default __webpack_public_path__ + "static/media/6osihdp.096a5b0d.webp";